<div class="container">
      <h1 class="page-title">
    <span class="icon"><i class="fas fa-cog"></i></span>{{ 'Menu.Menu.FSCSSCSetting' | translate }}</h1>
  <p-card>
      <form class="detail-form">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.SerialNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.seqNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.forwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.CostType' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.feeType | optionsMapping:feeTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Currency' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.currency | optionsMapping:currencyOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Status' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.status | optionsMapping:statusOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.DepartureCountry' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.fromCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.DestinationIATA' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.toIataArea | optionsMapping:iataAreaOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Amount' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.amount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.IsValid' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.isActivated | optionsMapping:isActivatedOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.EffectiveStart' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.startDt | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.EffectiveEnd' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.endDt | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Remarks' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.remark | optionsMapping:isActivatedOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline"></div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.Creator' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.CreationTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.UpdateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingDetail.UpdateTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button *ngIf="isShowEditBtn" pButton pRipple label="{{ 'Common.Button.Edit' | translate }}" (click)="goToEdit($event)" class="mr-2"></button>
              <button *ngIf="isShowCancelBtn" pButton pRipple label="{{ 'FSCSSCSettingDetail.Back' | translate }}" (click)="goToSearchPage()" class="p-button-secondary"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
